import styled from "@emotion/styled";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 15px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const Container = styled.div`
`;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
};

export default SC;
